// extracted by mini-css-extract-plugin
module.exports = {"button":"tab-button_button__ByloJ","selected_button":"tab-button_selected_button__nQ1gM","not_selected_button":"tab-button_not_selected_button__EB9fa"};